const paymentMethodMap: any = {
  'alternative payment': 'Alternative payment',
  'invoice payment': 'Account payment',
  'credit card payment': 'Credit card payment',
  'ach payment': 'ACH payment',
  'e wallet payment': 'E-wallet payment',
}
export {
  paymentMethodMap
}